import { IoLockClosed } from 'react-icons/io5';

function AsaasWordmark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 72 16"
      className={className}
      role="img"
      aria-label="Asaas"
    >
      <text
        x="0"
        y="13"
        fill="#0030B9"
        fontFamily="Arial, Helvetica, sans-serif"
        fontSize="14"
        fontWeight="700"
      >
        asaas
      </text>
    </svg>
  );
}

export default function AsaasSecureNote() {
  return (
    <p className="flex flex-wrap items-center gap-x-1.5 gap-y-1 text-xs text-muted-foreground">
      <IoLockClosed className="h-3.5 w-3.5 shrink-0 text-emerald-600" aria-hidden />
      <span>Pagamento seguro processado pela</span>
      <AsaasWordmark className="h-3.5 w-[4.5rem]" />
    </p>
  );
}
